import { classNamePrefix } from '../globals';
import { TImageAlignment } from '../types';

export function renderImage (
    source: string,
    alternative?: string,
    width?: string,
    height?: string,
    alignment?: TImageAlignment,
    parentClass?: string
) {
    const className = classNamePrefix + '-image';

    // Container
    const containerElement = document.createElement('div');
    containerElement.classList.add(className);

    // Inner
    const innerElement = document.createElement('div');
    innerElement.classList.add(className + '__inner');

    containerElement.appendChild(innerElement);

    if (parentClass) {
        containerElement.classList.add(parentClass);
    }

    if (width) {
        innerElement.style.width = width;
    }

    if (height) {
        innerElement.style.height = height;
    }

    switch (alignment) {
        case 'left':
            containerElement.classList.add(className + '--alignment-left');
            break;
        case 'right':
            containerElement.classList.add(className + '--alignment-right');
            break;
        default:
            containerElement.classList.add(className + '--alignment-center');
            break;
    }

    // Image
    const imageElement = document.createElement('img');
    imageElement.classList.add(className + '__image');
    imageElement.src = source;

    if (alternative !== undefined) {
        imageElement.alt = alternative;
    }

    innerElement.appendChild(imageElement);

    return containerElement;
}